var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 191,
    viewBox: "0 0 192 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40167e-08 147.01C5.40167e-08 141.767 5.40167e-08 138.607 5.40167e-08 135.447C0.011412 94.6002 5.21541e-08 53.7538 0.0342358 12.9074C0.0399418 0.916493 0.867307 0.0282793 12.4048 0.0225856C67.8439 -0.0115764 123.283 -0.00588277 178.722 0.0282793C190.619 0.0339729 190.26 0.905106 191.692 12.5202C193.404 26.39 187.983 34.27 176.069 40.7608C151.471 54.1524 130.478 71.3928 116.259 96.6158C105.161 116.293 87.8947 127.111 63.5816 125.767C44.8546 124.731 27.5313 131.609 11.3263 140.878C8.325 142.598 5.24378 144.181 0.011412 147.016L5.40167e-08 147.01Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190.677 44.2512C190.997 48.4475 191.396 51.2089 191.396 53.976C191.436 95.4658 191.453 136.961 191.413 178.451C191.402 190.3 190.689 190.983 178.718 190.983C123.598 191.006 68.4783 191.006 13.3587 190.977C0.446067 190.972 -0.107411 190.488 0.0409441 177.153C0.274889 156.138 -2.6751 162.401 15.5326 153.558C28.9359 147.051 43.0753 144.819 57.8595 147.529C59.7596 147.876 61.6711 148.178 63.5883 148.445C104.483 154.128 122.434 144.113 135.466 105.043C144.944 76.6255 165.719 59.9373 190.672 44.2512H190.677Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCls);
export default __webpack_public_path__ + "static/media/cls.c13791f81d4704b04df37abd004bd603.svg";
export { ForwardRef as ReactComponent };